export default __webpack_public_path__ + "static/media/01.8d9172a9.png";